export interface ArticleSection {
  id: string;
  heading: string;
  paragraphs: string[];
  bullets?: string[];
}

export interface ArticleMeta {
  id: number;
  slug: string;
  category: string;
  readMinutes: number;
  image: string;
}

export const articleList: ArticleMeta[] = [
  {
    id: 1,
    slug: "usfans-spreadsheet-guide",
    category: "Guide",
    readMinutes: 8,
    image:
      "https://readdy.ai/api/search-image?query=A%20clean%20minimal%20editorial%20photo%20of%20an%20organized%20product%20spreadsheet%20displayed%20on%20a%20laptop%20screen%20beside%20folded%20fashion%20items%20and%20a%20notebook%20on%20a%20warm%20cream%20desk%2C%20soft%20natural%20window%20light%2C%20calm%20neutral%20beige%20and%20sage%20green%20tones%2C%20high%20detail%20harmonious%20composition&width=1600&height=800&seq=usfans-article-hero-1&orientation=landscape",
  },
  {
    id: 2,
    slug: "usfans-review",
    category: "Review",
    readMinutes: 7,
    image:
      "https://readdy.ai/api/search-image?query=A%20neat%20desk%20scene%20with%20a%20tablet%20showing%20a%20product%20review%20page%20next%20to%20a%20coffee%20cup%20and%20a%20folded%20grey%20sweater%2C%20soft%20morning%20light%2C%20warm%20minimal%20editorial%20photography%2C%20neutral%20grey%20and%20cream%20tones%2C%20high%20detail&width=1600&height=800&seq=usfans-article-hero-2&orientation=landscape",
  },
  {
    id: 3,
    slug: "usfans-shipping-cost",
    category: "Shipping",
    readMinutes: 6,
    image:
      "https://readdy.ai/api/search-image?query=A%20stack%20of%20cardboard%20shipping%20boxes%20with%20a%20parcel%20scale%20and%20packing%20tape%20on%20a%20light%20wooden%20table%2C%20soft%20natural%20light%2C%20minimal%20editorial%20logistics%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1600&height=800&seq=usfans-article-hero-3&orientation=landscape",
  },
  {
    id: 4,
    slug: "usfans-coupon",
    category: "Coupons",
    readMinutes: 5,
    image:
      "https://readdy.ai/api/search-image?query=A%20smartphone%20showing%20a%20discount%20code%20screen%20beside%20a%20small%20gift%20box%20and%20a%20wallet%20on%20a%20soft%20pastel%20background%2C%20gentle%20daylight%2C%20minimal%20editorial%20ecommerce%20photography%2C%20fresh%20mint%20and%20cream%20tones%2C%20high%20detail&width=1600&height=800&seq=usfans-article-hero-4&orientation=landscape",
  },
  {
    id: 5,
    slug: "usfans-warehouse",
    category: "Warehouse",
    readMinutes: 6,
    image:
      "https://readdy.ai/api/search-image?query=An%20organized%20warehouse%20interior%20with%20neat%20shelves%20of%20labeled%20boxes%20and%20a%20worker%20holding%20a%20scanner%20in%20the%20distance%2C%20soft%20ambient%20light%2C%20clean%20modern%20editorial%20logistics%20photography%2C%20cool%20grey%20and%20warm%20wood%20tones%2C%20high%20detail&width=1600&height=800&seq=usfans-article-hero-5&orientation=landscape",
  },
  {
    id: 6,
    slug: "usfans-legit",
    category: "Safety",
    readMinutes: 6,
    image:
      "https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20hand%20holding%20a%20smartphone%20showing%20a%20secure%20website%20lock%20icon%20beside%20a%20notebook%20with%20a%20checklist%2C%20soft%20natural%20light%2C%20minimal%20editorial%20security%20themed%20photography%2C%20calm%20blue%20grey%20and%20white%20tones%2C%20high%20detail&width=1600&height=800&seq=usfans-article-hero-6&orientation=landscape",
  },
  {
    id: 7,
    slug: "usfans-w2c",
    category: "Finds",
    readMinutes: 5,
    image:
      "https://readdy.ai/api/search-image?query=A%20laptop%20screen%20with%20a%20grid%20of%20product%20thumbnail%20links%20beside%20a%20pair%20of%20sneakers%20and%20a%20mouse%20on%20a%20clean%20white%20desk%2C%20soft%20daylight%2C%20minimal%20editorial%20ecommerce%20photography%2C%20neutral%20tones%20with%20a%20pop%20of%20orange%2C%20high%20detail&width=1600&height=800&seq=usfans-article-hero-7&orientation=landscape",
  },
  {
    id: 8,
    slug: "usfans-qc",
    category: "QC",
    readMinutes: 7,
    image:
      "https://readdy.ai/api/search-image?query=A%20close%20up%20of%20hands%20inspecting%20a%20white%20sneaker%20stitching%20detail%20with%20a%20magnifying%20glass%20and%20a%20checklist%20on%20a%20light%20workbench%2C%20soft%20natural%20light%2C%20minimal%20editorial%20quality%20control%20photography%2C%20clean%20neutral%20tones%2C%20high%20detail&width=1600&height=800&seq=usfans-article-hero-8&orientation=landscape",
  },
  {
    id: 9,
    slug: "usfans-buying-guide",
    category: "Guide",
    readMinutes: 8,
    image:
      "https://readdy.ai/api/search-image?query=A%20step%20by%20step%20buying%20journey%20illustrated%20on%20a%20clean%20desk%20with%20a%20laptop%2C%20credit%20card%2C%20shipping%20box%20and%20a%20folded%20hoodie%20arranged%20in%20a%20line%2C%20soft%20daylight%2C%20minimal%20editorial%20commerce%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1600&height=800&seq=usfans-article-hero-9&orientation=landscape",
  },
  {
    id: 10,
    slug: "how-to-use-usfans",
    category: "Guide",
    readMinutes: 6,
    image:
      "https://readdy.ai/api/search-image?query=A%20person%20pointing%20at%20a%20colorful%20spreadsheet%20on%20a%20laptop%20screen%20with%20category%20columns%20visible%2C%20beside%20a%20notebook%20and%20a%20cup%20of%20tea%2C%20soft%20natural%20light%2C%20minimal%20editorial%20photography%2C%20calm%20neutral%20tones%2C%20high%20detail&width=1600&height=800&seq=usfans-article-hero-10&orientation=landscape",
  },
  {
    id: 11,
    slug: "usfans-finds",
    category: "Finds",
    readMinutes: 6,
    image:
      "https://readdy.ai/api/search-image?query=A%20bright%20flat%20lay%20of%20curated%20fashion%20finds%20including%20a%20cap%2C%20sunglasses%2C%20a%20belt%20and%20a%20small%20bag%20arranged%20on%20a%20soft%20sand%20background%2C%20gentle%20natural%20light%2C%20minimal%20editorial%20ecommerce%20photography%2C%20warm%20earthy%20tones%2C%20high%20detail&width=1600&height=800&seq=usfans-article-hero-11&orientation=landscape",
  },
];

// Full body sections. English is canonical for every article.
// pl / es / fr only carry the fully translated first article; other articles fall back to English.
const sectionsByLang: Record<string, Record<string, ArticleSection[]>> = {
  en: {
    "usfans-spreadsheet-guide": [
      {
        id: "what-is",
        heading: "What Is the USFans Spreadsheet?",
        paragraphs: [
          "The USFans Spreadsheet is an organized research resource that helps shoppers discover products, compare listings, review available information and understand the buying process before placing an order. Instead of searching through scattered links, it brings curated finds, W2C (where to cop) references, QC guidance and shipping notes into a single, browsable structure.",
          "Think of it as a map rather than a guarantee. The spreadsheet points you toward categories and listings that are commonly discussed, but it does not vouch for the quality, availability or reliability of any individual seller. Its real value is in saving you time during the research stage and giving you a clearer picture of what to check before you commit to a purchase.",
        ],
      },
      {
        id: "how-it-works",
        heading: "How Does the USFans Spreadsheet Work?",
        paragraphs: [
          "Most spreadsheets are organized around product categories such as shoes, hoodies, t-shirts, jackets, pants, headwear, bags and accessories. Each row or entry typically groups the product name, the category, the source or seller, a price range and any relevant notes about sizing or quality control.",
          "The purpose is to reduce the noise of browsing a large marketplace. Rather than opening dozens of tabs, you can scan one resource, shortlist a few items that match what you are looking for, and then move those items into the actual buying process with a clearer head.",
        ],
        bullets: [
          "Research products faster by scanning organized categories",
          "Compare listings and sellers side by side",
          "Understand what QC photos and size notes to look for",
          "Learn about shipping considerations before you order",
        ],
      },
      {
        id: "what-included",
        heading: "What Information Does the Spreadsheet Include?",
        paragraphs: [
          "A well-maintained spreadsheet usually covers several data points for each item. Product name and category help you find what you need, while source and seller information tells you where the item is listed. A price range gives a rough idea of cost, and QC or size notes highlight details worth inspecting before the item ships.",
          "Some spreadsheets also include a link status and a last-checked date, so you can tell at a glance whether an entry is still active. This is important because listings on third-party marketplaces can change or expire without notice.",
        ],
      },
      {
        id: "categories",
        heading: "Popular Categories to Explore",
        paragraphs: [
          "The USFans Spreadsheet typically organizes finds into a handful of broad categories. Shoes and sneakers are among the most common, followed by apparel like hoodies, t-shirts, jackets and pants. Accessories, bags, jerseys and headwear round out the list, with occasional sections for belts, perfumes and other miscellaneous items.",
          "If you are new to the resource, the fastest way to get oriented is to pick one category you care about and explore it first. From the USFansSheet home page you can jump straight to any category on the main store, which makes it easy to compare what is currently available.",
        ],
      },
      {
        id: "qc",
        heading: "Why QC and Shipping Matter Before Ordering",
        paragraphs: [
          "Two of the most important parts of the buying process are quality control (QC) and shipping. QC refers to the photos or checks that happen before an item is sent internationally. Learning to read these photos — checking stitching, labels, proportions and color — can help you spot issues before they leave the warehouse.",
          "Shipping is equally important because cost and time vary by parcel weight, dimensions, line and destination country. What seems like a good deal can become expensive once shipping is added, so it is worth understanding the numbers before you commit.",
        ],
      },
      {
        id: "safety",
        heading: "A Note on Research and Safety",
        paragraphs: [
          "No spreadsheet can guarantee product quality, seller reliability, availability or shipping results. The information on USFansSheet is provided for research and educational purposes, and listings, prices and conditions can change at any time.",
          "Always verify the current listing, seller and shipping terms before purchasing. If a deal looks too good to be true, or a link asks for sensitive information, step back and re-check. Research first, then order smarter.",
        ],
      },
    ],
    "usfans-review": [
      {
        id: "overview",
        heading: "USFans Review: An Overview",
        paragraphs: [
          "USFans is best understood as a shopping and shipping workflow rather than a single product. Buyers research items through an organized spreadsheet, submit links, review quality control photos and then arrange international delivery. Understanding that flow helps you set realistic expectations before you place a first order.",
          "The value of the USFans approach sits in the research stage. Because the spreadsheet groups finds by category and points to specific listings, it can save you time compared with searching a marketplace from scratch.",
        ],
      },
      {
        id: "what-to-look-for",
        heading: "What People Look For",
        paragraphs: [
          "Most users focus on three things: the breadth of the spreadsheet finds, the clarity of the QC process and the predictability of shipping. A useful spreadsheet makes it easy to compare items, while clear QC photos reduce the risk of surprises and clear shipping information helps you budget before ordering.",
          "None of these factors is a guarantee of a perfect result. Instead, treat them as the main areas to research and understand before you spend money.",
        ],
      },
      {
        id: "pros-considerations",
        heading: "Pros and Considerations",
        paragraphs: [
          "On the positive side, an organized spreadsheet can make product research faster, and a documented QC step gives you a chance to catch visible issues before an item ships. Shipping information also helps you compare costs across lines and destinations.",
          "The considerations are equally real. Listings can change or expire, shipping costs can vary, and no resource can fully guarantee seller reliability or product quality. A balanced approach means enjoying the structure while staying cautious about the unknowns.",
        ],
        bullets: [
          "Pros: faster research, organized categories, a documented QC step",
          "Considerations: listings can change, costs vary, no guaranteed results",
        ],
      },
      {
        id: "who-its-for",
        heading: "Who USFans Works Best For",
        paragraphs: [
          "USFans tends to suit buyers who are willing to research before ordering and who understand that international shipping involves multiple steps. If you are patient with the process and comfortable reviewing QC photos, the structure can work well for you.",
          "If you need instant results or expect a guarantee on every item, the model may feel frustrating. In that case, take extra time to read the buying and safety guides before committing to an order.",
        ],
      },
    ],
    "usfans-shipping-cost": [
      {
        id: "how-calculated",
        heading: "How USFans Shipping Cost Is Calculated",
        paragraphs: [
          "USFans shipping cost is driven by a few core factors: the actual or volumetric weight of the parcel, its dimensions, the shipping line you choose and the destination country. Heavier or bulkier packages generally cost more, and faster lines tend to carry a higher price than economy options.",
          "Volumetric weight matters especially for light but large items such as jackets or shoes in boxes. Carriers compare actual weight against a volumetric calculation and charge based on whichever is higher, so packaging choices directly affect the final cost.",
        ],
      },
      {
        id: "lines",
        heading: "Common Shipping Lines and Methods",
        paragraphs: [
          "Shipping lines usually range from economy sea or rail options to faster air freight. Economy lines are cheaper but slower, while air lines arrive sooner at a higher cost. The right choice depends on your budget, how quickly you need the parcel and the destination.",
          "Because rates and availability shift over time, it is worth checking the current line options and estimates at the point of ordering rather than relying on older figures.",
        ],
      },
      {
        id: "estimate-reduce",
        heading: "How to Estimate and Reduce Cost",
        paragraphs: [
          "The most reliable way to estimate cost is to enter the parcel weight and dimensions into the current shipping calculator, or to ask for a quote before committing. Consolidating multiple items into one parcel can also reduce the per-item shipping cost by combining them under a single weight bracket.",
          "Small changes can make a meaningful difference: removing bulky packaging, grouping items into one shipment and choosing a slower line when time allows are all practical ways to bring the total down.",
        ],
      },
      {
        id: "before-ordering",
        heading: "What to Check Before You Order",
        paragraphs: [
          "Before finalizing an order, confirm the estimated weight, the chosen shipping line, the destination and any extra fees such as customs or handling. These details together determine whether the total cost still makes sense for the item you are buying.",
          "Because prices, lines and conditions can change, always verify the current numbers rather than assuming an older quote still applies.",
        ],
      },
    ],
    "usfans-coupon": [
      {
        id: "where",
        heading: "Where USFans Coupons and Discount Codes Appear",
        paragraphs: [
          "USFans coupons and discount codes tend to appear in a few places: promotional banners, seasonal campaigns and occasionally through the shipping or account area. They are often tied to specific conditions, such as a minimum order value or a particular shipping line.",
          "Because these offers are temporary and change frequently, there is no single permanent code that always applies. Checking the current offer details at the moment you order is the most reliable approach.",
        ],
      },
      {
        id: "verify",
        heading: "How to Verify a Code Is Current",
        paragraphs: [
          "Always check three things before relying on a code: the expiration date, the applicable conditions and whether it has been confirmed recently. A code that looks valid but has expired, or that requires a minimum spend you will not reach, will not help your order.",
          "Treat any unverified code as information rather than a promise. If the offer cannot be confirmed through a current source, assume it may no longer apply.",
        ],
      },
      {
        id: "watch-out",
        heading: "What to Watch Out For",
        paragraphs: [
          "Be cautious around codes shared in comments or third-party forums, especially if they ask you to visit an unusual link or provide sensitive information. Legitimate offers do not require your password or payment details outside the normal checkout flow.",
          "If an offer looks too good to be true, step back and verify it through an official or clearly current source before proceeding.",
        ],
      },
      {
        id: "best-practice",
        heading: "Best Practice for Discounts",
        paragraphs: [
          "The simplest best practice is to review the latest verified offers, note the conditions and apply them only where they genuinely fit your order. Discounts are a bonus on top of good research, not a replacement for it.",
          "Remember that a small saving should never override safety checks, QC review and a clear understanding of shipping costs.",
        ],
      },
    ],
    "usfans-warehouse": [
      {
        id: "what-it-does",
        heading: "What the USFans Warehouse Does",
        paragraphs: [
          "The USFans warehouse acts as a middle step between the seller and your door. Items you order are delivered to the warehouse, where they can be inspected, stored and combined with other purchases before being shipped internationally.",
          "This step is useful because it lets you group multiple items into one parcel and review QC photos before the package leaves the country.",
        ],
      },
      {
        id: "qc",
        heading: "QC at the Warehouse",
        paragraphs: [
          "Quality control at the warehouse usually involves photographing the item from several angles so you can check details such as stitching, labels, color and proportions. These photos are your main chance to spot visible issues before the item ships.",
          "QC is a visual check, not a full guarantee of authenticity or long-term quality. Use the photos to catch obvious problems, but keep your expectations grounded.",
        ],
      },
      {
        id: "storage-consolidation",
        heading: "Storage and Parcel Consolidation",
        paragraphs: [
          "The warehouse can hold items for a period while you wait for other orders to arrive. Consolidation then combines several items into a single parcel, which can lower the overall shipping cost compared with sending each item separately.",
          "Check the current storage limits and consolidation rules before relying on a long hold, as these details can vary.",
        ],
      },
      {
        id: "shipping-out",
        heading: "Shipping From the Warehouse",
        paragraphs: [
          "Once you approve the QC photos and choose a shipping line, the warehouse prepares the parcel for international delivery. Weight, dimensions and destination then determine the final shipping cost.",
          "Because conditions and rates change, verify the current figures at the point of dispatch rather than assuming earlier estimates still apply.",
        ],
      },
    ],
    "usfans-legit": [
      {
        id: "quick-answer",
        heading: "Is USFans Legit? A Balanced Answer",
        paragraphs: [
          "USFans operates through a shopping and shipping model that many buyers use, but legitimacy is something you evaluate per transaction rather than assume once and for all. The platform structure itself does not guarantee that every seller or listing is reliable.",
          "The most useful approach is to treat USFans as a workflow, then apply your own checks to each seller, listing and offer before you commit money.",
        ],
      },
      {
        id: "evaluate-sellers",
        heading: "How to Evaluate Sellers and Listings",
        paragraphs: [
          "Look at the consistency of a listing, the clarity of its information and whether the seller responds clearly to questions. A listing with vague details, inconsistent photos or pressure to pay outside the normal flow deserves extra caution.",
          "Cross-checking information across sources and reviewing QC photos carefully are practical ways to reduce risk without relying on any single signal.",
        ],
      },
      {
        id: "red-flags",
        heading: "Common Red Flags to Research",
        paragraphs: [
          "Requests for payment outside the normal checkout, links that ask for passwords or sensitive details, and offers that seem unrealistically cheap are all signs to pause. A legitimate process should not require you to bypass the standard steps.",
          "None of these flags is proof of a scam by itself, but together they are a strong reason to slow down and verify before ordering.",
        ],
        bullets: [
          "Payment requests outside the normal checkout flow",
          "Links asking for passwords or sensitive information",
          "Offers that appear unrealistically cheap",
        ],
      },
      {
        id: "safety-tips",
        heading: "Safety Tips Before You Order",
        paragraphs: [
          "Research first, then order. Confirm the listing, the seller and the shipping terms, review QC photos when available, and keep your expectations realistic about quality and delivery.",
          "The information on USFansSheet is for research and education only. Always verify current details yourself before making a purchase.",
        ],
      },
    ],
    "usfans-w2c": [
      {
        id: "what-w2c",
        heading: "What W2C Means",
        paragraphs: [
          "W2C stands for where to cop, a shorthand used in fashion communities for where to find or buy a specific item. In the context of USFans, W2C links point you toward the listing or source for a product that appears in the spreadsheet.",
          "The term is about discovery rather than endorsement. A W2C link tells you where an item is listed, but it does not guarantee the quality, availability or reliability of that specific listing.",
        ],
      },
      {
        id: "how-work",
        heading: "How W2C Links Work in the Spreadsheet",
        paragraphs: [
          "Each spreadsheet entry often includes a W2C reference alongside the product name and category. Following the link takes you to the source listing, where you can check the current details, photos and any notes before deciding.",
          "Because marketplace listings change and expire, a W2C link that worked yesterday may not work today. Always re-check the current listing rather than assuming it is still active.",
        ],
      },
      {
        id: "use-safely",
        heading: "How to Use W2C Links Safely",
        paragraphs: [
          "Treat a W2C link as a starting point, not a final answer. Open the listing, compare it with the spreadsheet notes and check whether the seller, price and availability still match what you expect.",
          "Avoid sharing sensitive information through unusual links and stick to the normal marketplace flow. If a link redirects somewhere unexpected, stop and verify before continuing.",
        ],
      },
      {
        id: "where-find",
        heading: "Where to Find W2C Links",
        paragraphs: [
          "W2C references are typically included inside the organized spreadsheet itself, grouped by category. From the USFansSheet home page you can jump to the main store categories to compare currently available items.",
          "For the most current results, check the live category pages rather than relying on screenshots or older copies of a spreadsheet.",
        ],
      },
    ],
    "usfans-qc": [
      {
        id: "what-qc",
        heading: "What QC Means in the USFans Flow",
        paragraphs: [
          "QC stands for quality control. In the USFans flow it refers to the photos or checks performed before an item is shipped internationally. These images let you review the item you actually ordered, rather than relying only on the listing photos.",
          "QC is a visual review, not a full authenticity or long-term quality guarantee. Its purpose is to catch obvious problems early, while the item is still at the warehouse.",
        ],
      },
      {
        id: "what-check",
        heading: "What to Check in QC Photos",
        paragraphs: [
          "Look closely at stitching, labels, logos, color and proportions. Uneven stitching, misaligned labels or colors that differ noticeably from the listing are common issues to watch for.",
          "Compare the QC photos against the original listing and the product photos you expected. Small differences are normal, but major mismatches are worth questioning before the item ships.",
        ],
        bullets: [
          "Stitching and seams",
          "Labels, logos and tags",
          "Color and material tone",
          "Proportions and shape",
        ],
      },
      {
        id: "checklist",
        heading: "A Simple QC Checklist",
        paragraphs: [
          "Work through a short checklist for every item: does the color match, are the labels correct, is the stitching even, and does the shape look right. Checking the same points each time makes it easier to catch issues consistently.",
          "If something looks off, ask for additional photos or clarification before approving the item for shipping.",
        ],
      },
      {
        id: "why-matters",
        heading: "Why QC Matters Before Shipping",
        paragraphs: [
          "Catching an issue while the item is still at the warehouse is far easier than resolving it after international shipping. QC gives you a window to flag problems before they become expensive returns.",
          "Use that window carefully. A few minutes reviewing photos can save you from a mismatch you would otherwise only discover weeks later.",
        ],
      },
    ],
    "usfans-buying-guide": [
      {
        id: "research",
        heading: "Step 1: Research Before You Order",
        paragraphs: [
          "Start by browsing the organized spreadsheet categories to shortlist items that match what you want. Compare a few listings side by side and note the category, source and any sizing or QC details that stand out.",
          "Research is the step most people skip, but it is also where the biggest mistakes are avoided. A little time here makes the rest of the process smoother.",
        ],
      },
      {
        id: "order",
        heading: "Step 2: Submit and Order",
        paragraphs: [
          "Once you have shortlisted an item, submit the link through the normal ordering flow and confirm the details. Double-check the size, color and quantity before committing, because changes after this point can be harder to make.",
          "Keep your communication clear and stick to the standard process. Any request to pay outside the normal flow is a reason to pause.",
        ],
      },
      {
        id: "qc-ship",
        heading: "Step 3: Review QC, Then Ship",
        paragraphs: [
          "When the item arrives at the warehouse, review the QC photos against your checklist. Approve the item only when you are satisfied with what you see, then choose a shipping line and confirm the cost.",
          "Grouping multiple items into one parcel can reduce shipping cost, and choosing a slower line can save money when time is not critical.",
        ],
      },
      {
        id: "final-checklist",
        heading: "Your Final Buying Checklist",
        paragraphs: [
          "Before you finish, run through the essentials: listing verified, size and color confirmed, QC photos reviewed and shipping terms understood. If any of these is unclear, pause and clarify rather than rushing the order.",
          "A careful process does not eliminate every risk, but it removes the avoidable ones and helps you order with more confidence.",
        ],
        bullets: [
          "Verify the current listing and seller",
          "Confirm size, color and quantity",
          "Review QC photos against a checklist",
          "Understand shipping cost and line",
        ],
      },
    ],
    "how-to-use-usfans": [
      {
        id: "orient",
        heading: "Getting Oriented",
        paragraphs: [
          "The fastest way to start is to pick a single category you care about and explore it first. The USFansSheet home page lets you jump straight to any category on the main store, so you can see what is currently available without browsing everything at once.",
          "Resist the urge to open every category immediately. Focusing on one area first makes the structure easier to learn and helps you compare items more effectively.",
        ],
      },
      {
        id: "categories",
        heading: "Filtering by Category",
        paragraphs: [
          "Categories such as shoes, hoodies, t-shirts, jackets, pants, headwear, bags and accessories are the backbone of the spreadsheet. Starting from a category narrows the field and makes individual listings easier to compare.",
          "When a category feels too broad, look for sub-details such as color, size or style to narrow the results further.",
        ],
      },
      {
        id: "columns",
        heading: "Reading the Columns",
        paragraphs: [
          "Each entry typically includes the product name, category, source or seller, a price range and notes about sizing or QC. Reading these columns together gives you a full picture of an item without opening every link.",
          "Pay special attention to the link status and last-checked date when they are present, so you do not waste time on listings that may have expired.",
        ],
      },
      {
        id: "turn-into-orders",
        heading: "Turning Finds Into Orders",
        paragraphs: [
          "Once you have shortlisted an item, move it into the actual buying flow: submit the link, confirm the details, review QC and arrange shipping. The spreadsheet is the starting point, not the endpoint.",
          "Treat the whole process as research first, then order. That mindset keeps you from rushing into a purchase before the important details are clear.",
        ],
      },
    ],
    "usfans-finds": [
      {
        id: "what-finds",
        heading: "What USFans Finds Are",
        paragraphs: [
          "In the USFans context, a find is a product or listing that has been discovered and added to the organized spreadsheet. Finds are grouped by category so that shoppers can browse a curated set of items instead of searching from scratch.",
          "A find is a discovery, not a recommendation. It points you toward something worth looking at, but the responsibility to verify quality and reliability still sits with you.",
        ],
      },
      {
        id: "popular-categories",
        heading: "Popular Categories of Finds",
        paragraphs: [
          "Shoes and sneakers are usually the most common finds, followed by apparel such as hoodies, t-shirts, jackets and pants. Accessories, bags, jerseys and headwear round out the list, with smaller sections for belts, perfumes and other items.",
          "The popularity of a category reflects demand rather than quality, so use it as a guide for where to look, not a measure of what is best.",
        ],
      },
      {
        id: "organized",
        heading: "How Finds Are Organized",
        paragraphs: [
          "Finds are typically organized by category first, then by individual entry with the product name, source and relevant notes. This structure makes it easy to scan a category and compare several options at once.",
          "Good organization saves time but does not replace your own review. Always check the current listing and QC details before ordering.",
        ],
      },
      {
        id: "spot-good",
        heading: "Tips for Spotting a Good Find",
        paragraphs: [
          "A good find usually has clear information, consistent photos and a source that is still active. Look for entries with useful notes rather than bare links, and prefer listings you can verify against the current store.",
          "When in doubt, compare a few similar finds side by side. The differences between them often reveal more than any single listing could.",
        ],
      },
    ],
  },
  pl: {
    "usfans-spreadsheet-guide": [
      {
        id: "what-is",
        heading: "Czym jest USFans Spreadsheet?",
        paragraphs: [
          "USFans Spreadsheet to uporządkowane źródło researchu, które pomaga kupującym odkrywać produkty, porównywać oferty, sprawdzać dostępne informacje i rozumieć proces zakupowy przed złożeniem zamówienia. Zamiast przeszukiwać rozproszone linki, zbiera wybrane znaleziska, odnośniki W2C (where to cop), wskazówki QC i notatki o wysyłce w jedną przejrzystą strukturę.",
          "Traktuj to jak mapę, a nie gwarancję. Arkusz wskazuje kategorie i oferty, o których często się mówi, ale nie ręczy za jakość, dostępność ani wiarygodność konkretnego sprzedawcy. Jego prawdziwą wartością jest oszczędność czasu na etapie researchu i jaśniejszy obraz tego, co warto sprawdzić, zanim zdecydujesz się na zakup.",
        ],
      },
      {
        id: "how-it-works",
        heading: "Jak działa USFans Spreadsheet?",
        paragraphs: [
          "Większość arkuszy jest zorganizowana według kategorii produktów, takich jak buty, bluzy, t-shirty, kurtki, spodnie, nakrycia głowy, torby i akcesoria. Każdy wiersz lub wpis zazwyczaj grupuje nazwę produktu, kategorię, źródło lub sprzedawcę, zakres cenowy oraz istotne uwagi dotyczące rozmiaru lub kontroli jakości.",
          "Celem jest ograniczenie szumu związanego z przeglądaniem dużego marketplace'u. Zamiast otwierać dziesiątki kart, możesz przejrzeć jeden zasób, wybrać kilka pozycji pasujących do Twoich potrzeb, a następnie przenieść je do właściwego procesu zakupowego z jaśniejszym umysłem.",
        ],
        bullets: [
          "Szybciej researchuj produkty, skanując uporządkowane kategorie",
          "Porównuj oferty i sprzedawców obok siebie",
          "Zrozum, jakich zdjęć QC i notatek o rozmiarze szukać",
          "Poznaj kwestie wysyłki, zanim złożysz zamówienie",
        ],
      },
      {
        id: "what-included",
        heading: "Jakie informacje zawiera arkusz?",
        paragraphs: [
          "Dobrze utrzymany arkusz zwykle obejmuje kilka punktów danych dla każdego produktu. Nazwa i kategoria pomagają znaleźć to, czego potrzebujesz, a informacje o źródle i sprzedawcy wskazują, gdzie produkt jest wystawiony. Zakres cenowy daje ogólne pojęcie o koszcie, a uwagi QC lub rozmiarowe podkreślają szczegóły warte sprawdzenia przed wysyłką.",
          "Niektóre arkusze zawierają również status linku i datę ostatniego sprawdzenia, dzięki czemu od razu widzisz, czy wpis jest nadal aktywny. To ważne, ponieważ oferty na marketplace'ach zewnętrznych mogą się zmieniać lub wygasać bez ostrzeżenia.",
        ],
      },
      {
        id: "categories",
        heading: "Popularne kategorie do odkrycia",
        paragraphs: [
          "USFans Spreadsheet zazwyczaj porządkuje znaleziska w kilku szerokich kategoriach. Buty i sneakersy należą do najczęstszych, a tuż za nimi odzież, taka jak bluzy, t-shirty, kurtki i spodnie. Listę uzupełniają akcesoria, torby, koszulki sportowe i nakrycia głowy, z okazjonalnymi sekcjami na paski, perfumy i inne różne przedmioty.",
          "Jeśli dopiero zaczynasz korzystać z tego zasobu, najszybszym sposobem na rozeznanie jest wybranie jednej kategorii, która Cię interesuje, i zbadanie jej w pierwszej kolejności. Ze strony głównej USFansSheet możesz przejść bezpośrednio do dowolnej kategorii w głównym sklepie, co ułatwia porównanie aktualnie dostępnych produktów.",
        ],
      },
      {
        id: "qc",
        heading: "Dlaczego QC i wysyłka mają znaczenie przed zamówieniem",
        paragraphs: [
          "Dwa z najważniejszych elementów procesu zakupowego to kontrola jakości (QC) i wysyłka. QC odnosi się do zdjęć lub kontroli, które odbywają się przed międzynarodową wysyłką produktu. Nauka czytania tych zdjęć — sprawdzanie szwów, metek, proporcji i koloru — może pomóc wykryć problemy, zanim opuszczą magazyn.",
          "Wysyłka jest równie ważna, ponieważ koszt i czas zależą od wagi paczki, wymiarów, linii i kraju docelowego. To, co wygląda na dobrą okazję, może stać się drogie po doliczeniu wysyłki, dlatego warto zrozumieć liczby, zanim się zdecydujesz.",
        ],
      },
      {
        id: "safety",
        heading: "Uwaga na temat researchu i bezpieczeństwa",
        paragraphs: [
          "Żaden arkusz nie gwarantuje jakości produktu, wiarygodności sprzedawcy, dostępności ani rezultatów wysyłki. Informacje na USFansSheet są udostępniane w celach badawczych i edukacyjnych, a oferty, ceny i warunki mogą się zmieniać w każdej chwili.",
          "Zawsze weryfikuj aktualną ofertę, sprzedawcę i warunki wysyłki przed zakupem. Jeśli oferta wygląda zbyt dobrze, aby była prawdziwa, lub link prosi o wrażliwe dane, cofnij się i sprawdź ponownie. Najpierw research, potem mądrzejsze zamówienie.",
        ],
      },
    ],
  },
  es: {
    "usfans-spreadsheet-guide": [
      {
        id: "what-is",
        heading: "¿Qué es el USFans Spreadsheet?",
        paragraphs: [
          "El USFans Spreadsheet es un recurso de investigación organizado que ayuda a los compradores a descubrir productos, comparar ofertas, revisar la información disponible y entender el proceso de compra antes de hacer un pedido. En lugar de buscar entre enlaces dispersos, reúne hallazgos seleccionados, referencias W2C (where to cop), orientación de QC y notas de envío en una sola estructura navegable.",
          "Piénsalo como un mapa y no como una garantía. La hoja te orienta hacia categorías y listados de los que se suele hablar, pero no avala la calidad, disponibilidad ni fiabilidad de ningún vendedor en concreto. Su verdadero valor está en ahorrarte tiempo durante la fase de investigación y darte una imagen más clara de qué revisar antes de comprometerte con una compra.",
        ],
      },
      {
        id: "how-it-works",
        heading: "¿Cómo funciona el USFans Spreadsheet?",
        paragraphs: [
          "La mayoría de las hojas se organizan en torno a categorías de producto como zapatos, sudaderas, camisetas, chaquetas, pantalones, gorras, bolsos y accesorios. Cada fila o entrada suele agrupar el nombre del producto, la categoría, la fuente o vendedor, un rango de precio y notas relevantes sobre tallaje o control de calidad.",
          "El objetivo es reducir el ruido de navegar por un gran marketplace. En lugar de abrir decenas de pestañas, puedes escanear un solo recurso, preseleccionar algunos artículos que coincidan con lo que buscas y luego pasar esos artículos al proceso de compra real con la mente más clara.",
        ],
        bullets: [
          "Investiga productos más rápido escaneando categorías organizadas",
          "Compara listados y vendedores uno al lado del otro",
          "Entiende qué fotos de QC y notas de tallaje buscar",
          "Infórmate sobre el envío antes de hacer tu pedido",
        ],
      },
      {
        id: "what-included",
        heading: "¿Qué información incluye la hoja?",
        paragraphs: [
          "Una hoja bien mantenida suele cubrir varios puntos de datos para cada artículo. El nombre y la categoría del producto te ayudan a encontrar lo que necesitas, mientras que la información de la fuente y el vendedor te dice dónde está listado el artículo. Un rango de precio da una idea aproximada del coste, y las notas de QC o tallaje destacan detalles que vale la pena revisar antes del envío.",
          "Algunas hojas también incluyen el estado del enlace y una fecha de última comprobación, para que puedas ver de un vistazo si una entrada sigue activa. Esto es importante porque los listados en marketplaces de terceros pueden cambiar o caducar sin aviso.",
        ],
      },
      {
        id: "categories",
        heading: "Categorías populares para explorar",
        paragraphs: [
          "El USFans Spreadsheet suele organizar los hallazgos en unas cuantas categorías amplias. Los zapatos y las zapatillas están entre las más comunes, seguidos de ropa como sudaderas, camisetas, chaquetas y pantalones. Los accesorios, bolsos, camisetas deportivas y gorras completan la lista, con secciones ocasionales para cinturones, perfumes y otros artículos variados.",
          "Si eres nuevo en el recurso, la forma más rápida de orientarte es elegir una categoría que te interese y explorarla primero. Desde la página de inicio de USFansSheet puedes saltar directamente a cualquier categoría de la tienda principal, lo que facilita comparar lo que está disponible ahora mismo.",
        ],
      },
      {
        id: "qc",
        heading: "Por qué el QC y el envío importan antes de pedir",
        paragraphs: [
          "Dos de las partes más importantes del proceso de compra son el control de calidad (QC) y el envío. El QC se refiere a las fotos o comprobaciones que ocurren antes de que un artículo se envíe internacionalmente. Aprender a leer esas fotos — comprobando costuras, etiquetas, proporciones y color — puede ayudarte a detectar problemas antes de que salgan del almacén.",
          "El envío es igual de importante porque el coste y el tiempo varían según el peso, las dimensiones, la línea y el país de destino. Lo que parece una buena oferta puede volverse caro una vez añadido el envío, así que vale la pena entender los números antes de comprometerte.",
        ],
      },
      {
        id: "safety",
        heading: "Una nota sobre investigación y seguridad",
        paragraphs: [
          "Ninguna hoja puede garantizar la calidad del producto, la fiabilidad del vendedor, la disponibilidad ni el resultado del envío. La información de USFansSheet se ofrece con fines de investigación y educación, y los listados, precios y condiciones pueden cambiar en cualquier momento.",
          "Verifica siempre el listado, el vendedor y las condiciones de envío actuales antes de comprar. Si una oferta parece demasiado buena para ser verdad, o un enlace pide información sensible, retrocede y vuelve a comprobar. Investiga primero y pide con más cabeza después.",
        ],
      },
    ],
  },
  fr: {
    "usfans-spreadsheet-guide": [
      {
        id: "what-is",
        heading: "Qu'est-ce que l'USFans Spreadsheet ?",
        paragraphs: [
          "L'USFans Spreadsheet est une ressource de recherche organisée qui aide les acheteurs à découvrir des produits, comparer des offres, consulter les informations disponibles et comprendre le processus d'achat avant de passer commande. Au lieu de chercher parmi des liens dispersés, elle rassemble des trouvailles sélectionnées, des références W2C (where to cop), des conseils QC et des notes de livraison dans une seule structure navigable.",
          "Voyez-le comme une carte plutôt qu'une garantie. La feuille vous oriente vers des catégories et des annonces souvent évoquées, mais elle ne garantit ni la qualité, ni la disponibilité, ni la fiabilité d'un vendeur en particulier. Sa vraie valeur réside dans le temps gagné lors de la phase de recherche et dans une vision plus claire de ce qu'il faut vérifier avant de vous engager dans un achat.",
        ],
      },
      {
        id: "how-it-works",
        heading: "Comment fonctionne l'USFans Spreadsheet ?",
        paragraphs: [
          "La plupart des feuilles sont organisées autour de catégories de produits comme les chaussures, les hoodies, les t-shirts, les vestes, les pantalons, les couvre-chefs, les sacs et les accessoires. Chaque ligne ou entrée regroupe généralement le nom du produit, la catégorie, la source ou le vendeur, une fourchette de prix et des notes pertinentes sur la taille ou le contrôle qualité.",
          "Le but est de réduire le bruit de la navigation sur une grande marketplace. Plutôt que d'ouvrir des dizaines d'onglets, vous pouvez parcourir une seule ressource, présélectionner quelques articles qui correspondent à ce que vous cherchez, puis passer ces articles au processus d'achat réel avec un esprit plus clair.",
        ],
        bullets: [
          "Recherchez des produits plus vite en parcourant des catégories organisées",
          "Comparez les annonces et les vendeurs côte à côte",
          "Comprenez quelles photos QC et notes de taille rechercher",
          "Informez-vous sur la livraison avant de commander",
        ],
      },
      {
        id: "what-included",
        heading: "Quelles informations la feuille contient-elle ?",
        paragraphs: [
          "Une feuille bien tenue couvre généralement plusieurs points de données pour chaque article. Le nom du produit et la catégorie vous aident à trouver ce qu'il vous faut, tandis que la source et le vendeur indiquent où l'article est listé. Une fourchette de prix donne une idée approximative du coût, et les notes QC ou de taille soulignent les détails à vérifier avant l'envoi.",
          "Certaines feuilles incluent aussi l'état du lien et une date de dernière vérification, pour que vous puissiez voir en un coup d'œil si une entrée est encore active. C'est important car les annonces sur les marketplaces tierces peuvent changer ou expirer sans préavis.",
        ],
      },
      {
        id: "categories",
        heading: "Catégories populaires à explorer",
        paragraphs: [
          "L'USFans Spreadsheet organise généralement les trouvailles en quelques grandes catégories. Les chaussures et baskets figurent parmi les plus courantes, suivies des vêtements comme les hoodies, t-shirts, vestes et pantalons. Les accessoires, sacs, maillots et couvre-chefs complètent la liste, avec parfois des sections pour les ceintures, parfums et autres articles variés.",
          "Si vous débutez avec la ressource, le plus rapide pour vous repérer est de choisir une catégorie qui vous intéresse et de l'explorer en premier. Depuis la page d'accueil d'USFansSheet, vous pouvez accéder directement à n'importe quelle catégorie de la boutique principale, ce qui facilite la comparaison de ce qui est disponible en ce moment.",
        ],
      },
      {
        id: "qc",
        heading: "Pourquoi le QC et la livraison comptent avant de commander",
        paragraphs: [
          "Deux des parties les plus importantes du processus d'achat sont le contrôle qualité (QC) et la livraison. Le QC désigne les photos ou vérifications qui ont lieu avant l'envoi international d'un article. Apprendre à lire ces photos — vérifier les coutures, étiquettes, proportions et couleurs — peut vous aider à repérer les problèmes avant qu'ils ne quittent l'entrepôt.",
          "La livraison est tout aussi importante car le coût et le délai varient selon le poids du colis, ses dimensions, la ligne et le pays de destination. Ce qui semble être une bonne affaire peut devenir coûteux une fois la livraison ajoutée, il vaut donc la peine de comprendre les chiffres avant de vous engager.",
        ],
      },
      {
        id: "safety",
        heading: "Une note sur la recherche et la sécurité",
        paragraphs: [
          "Aucune feuille ne peut garantir la qualité du produit, la fiabilité du vendeur, la disponibilité ou le résultat de la livraison. Les informations d'USFansSheet sont fournies à des fins de recherche et d'éducation, et les annonces, prix et conditions peuvent changer à tout moment.",
          "Vérifiez toujours l'annonce, le vendeur et les conditions de livraison actuels avant d'acheter. Si une offre semble trop belle pour être vraie, ou si un lien demande des informations sensibles, reculez et revérifiez. Recherchez d'abord, commandez ensuite plus intelligemment.",
        ],
      },
    ],
  },
};

export function getArticleSections(lang: string, slug: string): ArticleSection[] {
  return sectionsByLang[lang]?.[slug] || sectionsByLang.en[slug] || [];
}